import { NgModule } from '@angular/core';
import { IonicModule } from 'ionic-angular';

import { LogoLoader } from './logo-loader.directive';


/**
 * Módulo de la directiva LogoLoader.
 *
 * @export
 * @class LogoLoaderModule
 */
@NgModule({
  declarations: [
    LogoLoader
  ],
  providers: [
  ],
  imports: [
    IonicModule,
  ],
  entryComponents: [
  ],
  exports: [
    LogoLoader
  ]
})

export class LogoLoaderModule{ }



// WEBPACK FOOTER //
// ./src/modules/utils/logo-loader/logo-loader.module.ts